import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse, transformKeysToSnakeCase } from 'helpers/core';
import _isNil from 'lodash/isNil';
import URLS from 'constants/urls';

const OVERRIDE_FIELDS = ['latitude', 'longitude', 'howToGetThere', 'whatToBring', 'locationType'];

const sendUpdates = (httpClient, detailsEndpoint, overridesEndpoint, fieldUpdates) => {
  const payloads = Object.entries(fieldUpdates).reduce(
    ({ details, overrides }, [k, v]) => {
      if (!v) {
        return { details, overrides };
      }

      let updatedDetails = details;
      let updatedOverrides = overrides;

      if (OVERRIDE_FIELDS.includes(k)) {
        updatedOverrides = { ...overrides, [k]: v };
      } else {
        updatedDetails = { ...details, [k]: v };
      }

      return {
        details: updatedDetails,
        overrides: updatedOverrides,
      };
    },
    { details: {}, overrides: {} }
  );
  const { details, overrides } = payloads;

  // These two calls are intentionally made in series instead of parallel because
  // the overrides call has the potential to modify the tags of a class, so the
  // tags need to be settled before that call goes through.
  return httpClient
    .patch(detailsEndpoint, transformKeysToSnakeCase(details))
    .then(() => httpClient.post(overridesEndpoint, transformKeysToSnakeCase(overrides)));
};

const handler = ({ httpClient }, venueId, classId, fieldUpdates) => {
  let promise = Promise.resolve();

  const detailsReadEndpoint = URLS.class.detailsRead(classId);
  const detailsUpdateEndpoint = URLS.class.update(classId);
  const overridesEndpoint = URLS.class.overrides(venueId, classId);

  if (!_isNil(fieldUpdates)) {
    promise = sendUpdates(httpClient, detailsUpdateEndpoint, overridesEndpoint, fieldUpdates);
  }

  return promise
    .then(() =>
      Promise.all([
        httpClient.get(detailsReadEndpoint).then(transformV2ClientResponse),
        httpClient.get(overridesEndpoint).then(transformV2ClientResponse),
      ])
    )
    .then(responses => Object.assign({}, ...responses));
};

export default makeEntityScaffold('SAGA.API.CLASS_DETAIL', handler, {
  defaultKey: 2,
});
